<template lang="html">
  <div class="search-tag-bar">
    <span class="search-tag-bar__count">
      {{ count }} {{ count === 1 ? "result" : "results" }} for “{{ term }}”
    </span>

    <form
      v-if="editing"
      class="ui small action input search-tag-bar__form"
      @submit.prevent="submit"
    >
      <input
        ref="tagInput"
        v-model="tag"
        type="text"
        aria-label="Tag name"
        placeholder="Tag name"
        :disabled="saving"
      />
      <button
        type="submit"
        class="ui small primary button"
        :class="{ loading: saving }"
        :disabled="saving || !tag.trim() || !!tagError"
      >
        Add tag
      </button>
      <button
        type="button"
        class="ui small basic button"
        :disabled="saving"
        @click="editing = false"
      >
        Cancel
      </button>
    </form>
    <span v-if="editing && tagError" class="search-tag-bar__error">
      {{ tagError }}
    </span>

    <button
      v-else
      type="button"
      class="ui small basic button search-tag-bar__start"
      @click="start"
    >
      <i class="tag icon" />
      Tag all {{ count }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    term: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
    // Returns a promise resolving to {tagged_ids, skipped}.
    onTag: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      editing: false,
      saving: false,
      tag: "",
    };
  },
  computed: {
    // Mirrors DeliverablesController#bulk_tag: the tag list is
    // comma-delimited, so a comma would split one tag into two.
    tagError() {
      return this.tag.includes(",") ? "Tags can't contain commas" : null;
    },
  },
  methods: {
    start() {
      this.tag = this.term;
      this.editing = true;
      this.$nextTick(() => this.$refs.tagInput && this.$refs.tagInput.select());
    },
    submit() {
      const tag = this.tag.trim();
      if (!tag || this.tagError) return;
      this.saving = true;
      this.onTag(tag)
        .then((res) => {
          const tagged = res.tagged_ids.length;
          let message = `Tagged ${tagged} ${
            tagged === 1 ? "item" : "items"
          } “${tag}”`;
          if (res.skipped > 0) {
            message += `. ${res.skipped} you can't edit were skipped`;
          }
          this.$toasted.show(message, { duration: 4000 });
          this.editing = false;
        })
        .catch((err) => {
          // The server writes all or nothing, so a failure means nothing
          // was tagged; its message says so.
          const message =
            (err &&
              err.response &&
              err.response.data &&
              err.response.data.error) ||
            "Couldn't add the tag. Nothing was changed.";
          this.$toasted.error(message, { duration: 4000 });
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.search-tag-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 1rem;
  padding: 0.5rem 1rem;
  color: var(--text-secondary);
}

.search-tag-bar__form {
  flex: 0 1 420px;
  min-width: 260px;
}

.search-tag-bar__start {
  margin: 0;
}

.search-tag-bar__error {
  color: var(--color-error);
}
</style>
